import config from "../config";
// 共用現有 API 與語言設定；找回密碼和付款查詢不建立第二套服務。
export async function feedbackRequest(
  path: string,
  body?: unknown,
  signal?: AbortSignal,
) {
  const token = localStorage.getItem("jwt_token");
  const response = await fetch(config.REACT_APP_API.replace(/\/$/, "") + path, {
    method: body === undefined ? "GET" : "POST",
    signal,
    headers: {
      "Content-Type": "application/json",
      "Accept-Language": localStorage.getItem("jwt_language") || "zh-HK",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const result = await response.json();
  if (!response.ok || result.code !== 200)
    throw new Error(result.message || "Request failed");
  return result.data;
}
